<div class="w-full max-w-lg bg-white rounded-xl shadow-lg overflow-hidden">
    <div class="bg-yellow-50 p-6 flex flex-col items-center border-b-4 border-yellow-600">
        <div class="text-4xl text-yellow-800">
            <mat-icon inline aria-hidden="false">event_busy</mat-icon>
        </div>
        <h1 class="text-yellow-900 text-2xl font-bold">Enrollment Window Closed</h1>
    </div>
    
    <div class="p-6">
        <p class="text-gray-600 text-center mb-6">
            The enrollment period for this program has ended and is no longer accepting new enrollments.
        </p>
    
        <div class="bg-gray-50 rounded-lg p-4 mb-6">
            <h2 class="text-lg font-semibold text-gray-800 mb-2">What does this mean?</h2>
            <ul class="text-gray-600 space-y-2 list-disc list-inside">
                <li>The enrollment window has officially closed</li>
                <li>New enrollments are no longer being accepted</li>
                <li>You may need to wait for the next enrollment period</li>
            </ul>
        </div>
        
        <div class="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-500">
            <h2 class="text-lg font-semibold text-gray-800 mb-2">Need Help?</h2>
            <p class="text-gray-600">
                Please contact your administrator or HR department for information about future enrollment opportunities.
            </p>
        </div>
    </div>
</div>
